import { computed } from 'vue'
import { TERMINALS_NOT_REQUIRING_EMPTY_APPOINTMENTS_FOR_DUALS } from '~/constants'
import type { Appointment } from '~/models/appointments'
import type { GETShippingLine, TerminalName } from '~/services/apiClient'
import { TerminalName as Terminal } from '~/services/apiClient'

interface UseSwapEmptyFeaturesProps {
  appointment: Appointment
  showReturnRules: boolean
  terminal: Ref<TerminalName>
  form: {
    empty_container_number: string
    container_type?: string
  }
  loadingEmptyData: Ref<boolean>
  selectedShippingLine: ComputedRef<GETShippingLine | null | undefined>
}

export function useSwapEmptyFeatures(props: UseSwapEmptyFeaturesProps) {
  const shouldShowDualAlert = computed(() => {
    return (
      props.terminal.value &&
      TERMINALS_NOT_REQUIRING_EMPTY_APPOINTMENTS_FOR_DUALS.has(
        props.terminal.value
      ) &&
      props.appointment.is_dual
    )
  })

  const shouldShowChassisFields = computed(() => {
    return props.terminal.value === Terminal.Everport
  })

  const shouldShowReceivingRules = computed(() => {
    return (
      props.selectedShippingLine.value &&
      props.form.container_type &&
      props.showReturnRules
    )
  })

  const shouldShowSwapButton = computed(() => {
    return (
      props.terminal.value &&
      TERMINALS_NOT_REQUIRING_EMPTY_APPOINTMENTS_FOR_DUALS.has(
        props.terminal.value
      ) === false
    )
  })

  const isSwapButtonDisabled = computed(() => {
    return !props.form.empty_container_number || props.loadingEmptyData.value
  })

  const shouldShowBetaWarning = computed(() => {
    return props.appointment.linked_appointments.length > 0
  })

  return {
    shouldShowDualAlert,
    shouldShowChassisFields,
    shouldShowReceivingRules,
    shouldShowSwapButton,
    isSwapButtonDisabled,
    shouldShowBetaWarning,
  }
}
